import React from "react";
import "./description.css";

const Description = () => (
    <section className="site-description-container description-entrance">
        <div className="site-description-content">
            <h1 className="site-description-title">Apto Websites</h1>
            <p className="site-description-text">
                Elevate your real estate business with a modern, mobile-friendly website.
                Apto Websites delivers beautiful, customizable designs, IDX integration, and powerful marketing tools—all in one affordable package. 
                Whether you’re an agent, team, or brokerage, we make it easy to stand out, attract leads, and grow your brand online.
            </p>
        </div>
    </section>
);

export default Description;
